import { render } from "./InvitedToQuote.vue?vue&type=template&id=487cab2a&scoped=true"
import script from "./InvitedToQuote.vue?vue&type=script&lang=js"
export * from "./InvitedToQuote.vue?vue&type=script&lang=js"

import "./InvitedToQuote.vue?vue&type=style&index=0&id=487cab2a&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3554799265/src/syndesi-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-487cab2a"]])

export default __exports__